import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import { Map as SMMap, Marker, Route } from 'sm-react-components';

const colors = [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B'
];

const styles = {
    marker: {
        boxSizing: 'border-box',
        height: '16px',
        width: '16px',
        border: '2px solid #FFFFFF',
        backgroundColor: 'black',
        boxShadow: '0 5px 10px 0 rgba(0,0,0,0.5)',
        borderRadius: '50%',
        fontWeight: 'bold',
        fontSize: '10px',
        textAlign: 'center'
    }
};

colors.forEach((color, index) => {
    styles[`marker${index}`] = {
        ...styles.marker,
        backgroundColor: color
    };
});

class Map extends Component {
    render() {
        const { markers, paths } = this.props;
        return (
            <SMMap height={500}>
                {(markers || []).map((marker, index) => (
                    <Marker
                        key={index}
                        lat={marker.lat}
                        lng={marker.lng}
                        color={marker.color}
                        label={marker.label}
                    />
                ))}
                {(paths || []).map(({ path, color }, index) => {
                    if (color === undefined) {
                        color = 0;
                    }
                    return <Route key={`path_${index}`} path={path} color={color} />;
                })}
            </SMMap>
        );
    }
}

export default withStyles(styles)(Map);
